module.exports = __webpack_public_path__ + "img/watermark-on.4ce5aef3.svg";